import { storeToRefs } from "pinia";

export const useFetchStores = () => {
	const { getAllStores } = useNorcePwa();
	const { stores } = storeToRefs(useWarehousesAndStores());

	const { locale } = useI18n();

	const fetchStores = async () => {
		let fetchedStores = stores.value[locale.value];
		if (!fetchedStores?.length) {
			useWarehousesAndStores().setFetchedStores(true);
			fetchedStores = await getAllStores({
				...useNorceStore().storeContext
			});
			useWarehousesAndStores().setStores({ [locale.value]: fetchedStores });
		}

		return fetchedStores;
	};

	return { fetchStores };
};
